export default __webpack_public_path__ + "static/impact-hero-image-1-4bbce8ce076e6c57a604d0354741b038.jpg";